import { createInjectionKey } from "../../_utils/index.mjs";
export const notificationProviderInjectionKey = createInjectionKey('n-notification-provider');